
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/launch",
      function () {
        return require("private-next-pages/launch.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/launch"])
      });
    }
  